// @flow
import React from 'react';

import { StyledLabel } from '../../../common-utils/styledComponents';

export const GlobalDiscountNoteContainer = () => (
  <StyledLabel>Note: Global Discounts don&apos;t stack on any discounts added below</StyledLabel>
);
